<template>
    <div class="product-classify-container">
        <template v-for="(category, key) in categorySub">
            <div class="product-classify-type">
            <div class="product-classify-title">
                <i></i>
                <p>{{ category.value }}</p>
            </div>
            <v-card class="product-classify-card" flat>
                <div class="product-classify-card-left">
                    <div class="card-tab">
                        <div class="card-left-con card-img" @click="toDetail(category.code)">
                            <img :src="categoryImages[category.code]['small']" />
                            <div class="img-text-con"></div>
                            <p>{{ category.value }}</p>
                        </div>
                        <div class="card-product-recommend card-left-con recommend-one"
                             @click="toProductDetail(products[key]['detail'][0]['toUrl'])"
                        >
                            <v-img :src="products[key]['images'][0]"
                                   height="100%"
                                   style="padding: 20px;"
                                   class="image-background-product"
                            >
                                <div class="card-title">{{ products[key]['detail'][0]['title'] }}</div>
                                <ul>
                                    <li v-for="(item, kk) in products[key]['detail'][0]['content']">
                                        {{ item }}</li>
                                </ul>
                            </v-img>
                        </div>
                    </div>
                </div>
                <div class="product-classify-card-right">
                    <div class="card-product-recommend recommend-two"
                         @click="toProductDetail(products[key]['detail'][1]['toUrl'])"
                    >
                        <v-img :src="products[key]['images'][1]" height="100%" style="padding: 20px" class="image-background-product">
                        <div class="card-title">{{ products[key]['detail'][1]['title'] }}</div>
                        <ul>
                            <li v-for="(item, kk) in products[key]['detail'][1]['content']">
                                {{ item }}</li>
                        </ul>
<!--                        <div class="recommend-img-two-three">-->
<!--                            <img src="/images/web_product/type/recommend-two.png">-->
<!--                        </div>-->
                        </v-img>
                    </div>
                    <div class="card-product-recommend recommend-three"
                         @click="toProductDetail(products[key]['detail'][2]['toUrl'])"
                    >
                        <v-img :src="products[key]['images'][2]" height="100%" style="padding: 20px" class="image-background-product">
                            <div class="card-title">{{ products[key]['detail'][2]['title'] }}</div>
                            <ul>
                                <li v-for="(item, kk) in products[key]['detail'][2]['content']">
                                    {{ item }}</li>
                            </ul>
<!--                            <div class="recommend-img-two-three">-->
<!--                                <img src="/images/web_product/type/recommend-three.png">-->
<!--                            </div>-->
                        </v-img>
                    </div>
                </div>
            </v-card>
        </div>
        </template>
    </div>
</template>

<script>
    export default {
        props:{
            categorySub: {
                type: Array,
                default: []
            },
            categoryImages:{
                type: Object,
                default: {}
            }
        },
        data(){
            return {
                products: [
                    {
                        images: [
                            "/images/web_product/bg-1-1.png",
                            "/images/web_product/bg-1-2-new.png",
                            "/images/web_product/bg-1-3-new.png",
                        ],
                        detail: [
                            {
                                title: "团体意外险方案",
                                content: [
                                    "1-6类，可涉高",
                                    "10-100万额度广，扩展非社保用药",
                                    "可扩展员工海外出差至全球范围，仅限单次旅行不超过30天",
                                ],
                                toUrl: "2031"
                            },
                            {
                                title: "至尊保 - 京东安联境外旅行保障计划",
                                content: [
                                    "保障国际旅行的常见风险",
                                    "旅行医疗费用最高1百万",
                                ],
                                toUrl: "2033"
                            },
                            {
                                title: "史带财险团体商务旅行意外保险（通用版）",
                                content: [
                                    "公共交通工具意外、旅行延误、",
                                    "财务损失赔偿、医疗救援",
                                ],
                                toUrl:"2028"
                            },
                        ]
                    },
                    {
                        images: [
                            "/images/web_product/bg-2-1-new1.jpg",
                            "/images/web_product/bg-2-2-new.png",
                            "/images/web_product/bg-2-3.png",
                        ],
                        detail: [
                            {
                                title: (new Date().getTime()) < 1680278400000 ? "工意保" : "公众责任百万迷你保",
                                content: (new Date().getTime()) < 1680278400000 ? [
                                    "工伤死亡伤残最高保额100万",
                                    "附加24小时非公意外",
                                    "16-69周岁均可保",
                                ] : [
                                    "适用类型：美容服务、工作室、商场内商铺",
                                    "投保人 / 被保险人为实际经营业主，不支持物业方投保",
                                ],
                                toUrl: (new Date().getTime()) < 1680278400000 ? "2027" : 2037
                            },
                            {
                                title: "电梯行业雇主责任险",
                                content: [
                                    "仅承保电梯维修工、安装工及管理人员",
                                    "高保障 低保费",
                                ],
                                toUrl:"2049"
                            },
                            {
                                title: "外卖/商超食品安全责任保险",
                                content: [
                                    "适用类型：外卖店、超市、便利店、餐厅、食堂",
                                ],
                                toUrl:"2036"
                            },
                        ]
                    },
                    {
                        images: [
                            "/images/web_product/bg-3-1.png",
                            "/images/web_product/bg-3-2.png",
                            "/images/web_product/bg-3-3-new.png",
                        ],
                        detail: [
                            {
                                title: "安享华屋装修工程险",
                                content: [
                                    "物损 + 三者全面保障",
                                    "保额高达 400 万",
                                    "保费低至 800 元",
                                ],
                                toUrl:"2038"
                            },
                            {
                                title: "装修工程险",
                                content: [
                                    // "中小企业的守护保",
                                    // "资产存货皆可保 经营场所第三者责任",
                                    "火灾、水暖管爆裂",
                                    "不限装修工期长短",
                                    "五种定额方案，自由组合",
                                ],
                                toUrl:"2039"
                            },
                            {
                                title: "餐饮企业综合保险",
                                content: [
                                    "试用类型：500 ㎡内的餐饮企业",
                                    "保资产、保顾客、保员工",
                                ],
                                toUrl:"2041"
                            },
                        ]
                    }
                ]
            }
        },
        methods:{
            toDetail(category){
                this.$emit("toProductDetail",category);
            },
            toProductDetail(id){
                this.$router.push(`/product/new/detail/${id}`);
            }
        }
    }
</script>

<style lang="scss" >
    div.product-classify-container{
        width: 100%;
        margin-top: 20px;
        .product-classify-type{
            position: relative;
            cursor: pointer;
            margin-bottom: 100px;
            .product-classify-title{
                position: relative;
                height: 50px;
                margin-bottom: 10px;
                i{
                    position: absolute;
                    left: 0;
                    border: 5px;
                    background-color: #dd122a;
                    height: 80%;
                    top: 10%;
                    width: 8px;
                }
                p {
                    position: absolute;
                    font-weight: bold;
                    font-size: 30px;
                    color: #555;
                    left: 20px;
                    line-height: 50px;
                }
            }
            .product-classify-card{
                position: relative;
                width: 100%;
                height: 0;
                padding-bottom: 30%;
                div.card-product-recommend{
                    .card-title{
                        color: #555555;
                        font-size: 19px;
                        font-weight: bold;
                    }
                    font-size: 16px;
                    ul{
                        margin-top: 10px;
                        list-style: none;
                        padding-left: 0;
                        padding-right: 0;
                        li{
                            /*color: red;*/
                            font-size: 12px;
                        }
                    }
                }
                .product-classify-card-left {
                    width: 50%;
                    height: 100%;
                    position: absolute;
                    left: 0;
                    div.card-tab {
                        position: relative;
                        height: 100%;
                        border-right: 1px solid #E9E9E9;
                        .card-left-con{
                            float: left;
                            width: 50%;
                            height: 100%;
                        }
                        .card-img {
                            height: 100%;
                            img {
                                position: relative;
                                width: 100%;
                                height: 100%;
                            }
                            div.img-text-con{
                                position: absolute;
                                bottom: 0;
                                background-color: #000;
                                opacity: 0.3;
                                height: 60px;
                                width: 50%;
                                margin-bottom: 0;
                            }
                            p{
                                position: absolute;
                                bottom: 0;
                                margin-bottom: 0;
                                color: #fff;
                                font-size: 18px;
                                font-weight: bold;
                                text-align: center;
                                line-height: 60px;
                                width: 50%;
                                height: 60px;
                            }
                        }
                        .recommend-one{
                            position: relative;
                            .recommend-img-one{
                                position: absolute;
                                z-index: -1;
                                bottom: 0;
                                right: 0;
                                height: 80%;
                                width: 80%;
                                img{
                                    position: relative;
                                    height: 100%;
                                    width: 100%;
                                }
                            }
                        }
                    }
                }
                .product-classify-card-right{
                    width: 50%;
                    height: 100%;
                    position: absolute;
                    right: 0;
                    .recommend-img-two-three{
                        right: 0;
                        bottom: 0;
                        height: 100%;
                        width: 80%;
                    }
                    .recommend-two{
                        height: 50%;
                        border-bottom: 1px solid #E9E9E9;
                        position: relative;
                        .recommend-img-two-three{
                            position: absolute;
                            z-index: -1;
                            img{
                                position: absolute;
                                right: 0;
                                width: 80%;
                                height: 100%;
                            }
                        }
                    }
                    .recommend-three{
                        height: 50%;
                        position: relative;
                        .recommend-img-two-three{
                            position: absolute;
                            z-index: -1;
                            img{
                                position: absolute;
                                right: 0;
                                width: 50%;
                                height: 100%;
                            }
                        }
                    }
                }
            }
        }

    }

    @media only screen and (max-width: 1280px) {
        .product-classify-container{
            .card-title{
                font-size: 16px !important;
            }
            .v-image__image{
                opacity: 0.5 !important;
            }
        }
    }

    @media only screen and (max-width: 540px) {
        .product-classify-container{
            ul{
                opacity: 0;
            }
            .image-background-product{
                padding: 0.7em !important;
            }
            .card-title{
                font-size: 13px !important;
            }
            .product-classify-card-left {
                .recommend-one{
                    .card-title {
                        height: 89px;
                        overflow: hidden;
                    }
                }
            }
            .product-classify-card-right{
                .card-title {
                    height: 42px;
                    overflow: hidden;
                }
            }
            .card-img {
                p{
                    font-size: 14px !important;
                }
            }
        }
        .card-img,.img-li-con {
            div.img-text-con {
                height: 3rem !important;
                font-size: 14px !important;
            }

            p {
                height: 3rem !important;
                line-height: 3rem !important;
                font-size: 16px !important;
                overflow: hidden !important;
            }
        }
    }
</style>
